import { OrderServiceInterface } from './interface';
import { orderBaseDataLoader } from './orderBaseDataLoader';
import { orderProductLoader } from './orderProductsLoader';
import { OrderService } from './OrderService';

// Фабрика сервиса
export const orderService: { (token: string): OrderServiceInterface } = (token) =>
  new OrderService(orderBaseDataLoader(token), orderProductLoader(token));
